import { Component } from '@angular/core';

@Component({
  selector: 'app-available-subs',
  templateUrl: './available-subs.component.html',
  styleUrls: ['./available-subs.component.scss'],

  standalone: false,
})
/* istanbul ignore next */
export class AvailableSubsComponent {
  showDetails = false;
  /* istanbul ignore next */
  toggleStanleyDetails() {
    this.showDetails = !this.showDetails;
  }
  /* istanbul ignore next */
  purchaseSubscription() {
    // Implement your purchase logic here
    console.log('Purchase Subscription clicked');
  }
}
